import { Component, Input, OnInit, booleanAttribute, numberAttribute } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../base/input.component';
import { roundToNumber } from '../../map/types/location.types';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule],
    selector: 'wd-number',
    templateUrl: 'number-view.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/view-only.component.css'],
})
export class NumberViewComponent extends InputComponent<number> implements OnInit {
	@Input({transform: numberAttribute}) min?: number;
	@Input({transform: numberAttribute}) max?: number;

	@Input({transform: booleanAttribute}) integer? = false;

	roundToNumber = roundToNumber;

	constructor() {
		super();
	}

	override ngOnInit(): void {
		super.ngOnInit();

		const opt = this.os.option(this.name);
		if (opt) {
			if (opt.min !== undefined) this.min = opt.min;
			if (opt.max !== undefined) this.max = opt.max;
			if (opt.integer !== undefined) this.integer = opt.integer;
		}
	}

	protected override baseValidate(): boolean {
		if (!super.baseValidate()) return this.successOnDanger();
		if (this.model === undefined) return true;

		// Bei integer=true wird der Wert sowieso gerundet angezeigt, daher keine Validierung nötig
		if (this.integer) return true;

		if (this.min && (this.model < this.min!)) {
			this.danger("Wert zu klein");
			return this.successOnDanger();
		}

		if (this.max && (this.model > this.max!)) {
			this.danger("Wert zu groß");
			return this.successOnDanger();
		}

		const toNum = parseFloat(this.model?.toString());
		if (this.model !== null && this.model !== undefined && !Number.isNaN(this.model) && toNum !== this.model) {
			this.danger("Eine Zahl wird erwartet");
			return this.successOnDanger();
		}

		return true;
	}
}
